export const useApi = () => {
    const apiCall = async ({ url, options = {}, retries = 0 }: { url: string; options: object; retries: number }): Promise<any> => {
        const retryApiCall = () => {
            return apiCall({ url, options, retries: retries - 1 })
        }

        const response = await fetch(url, options)
        if (response.ok) return await response.json()

        // Abort if server error, bad request or resource not found, otherwise attempt retry
        if (response.status === 500 || response.status === 400 || response.status === 404) throw { message: await response.text(), status: response.status }
        else if (retries > 0) return retryApiCall()

        // Throw error if no retries left
        if (!response.ok) throw response
    }

    return { apiCall }
}
